import React from 'react';
import GroupHeader from '../GroupHeader';
import GroupStatistics from '../GroupStatistics';
import WorklogCard from '../WorklogCard';
import WorklogRow from '../WorklogRow';
import TableHeader from '../TableHeader';

const GeneralGroupedView = ({ 
  groupedWorkLogs, 
  grouping, 
  filteredWorkLogs,
  onToggleGroupExpansion,
  headerControls 
}) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm">
      <div className="px-4 sm:px-6 py-3 border-b border-gray-200 dark:border-white/10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <div className="min-w-0 flex-shrink">
            <h3 className="text-lg font-medium text-gray-900 dark:text-slate-100">
              Grouped Worklog Entries ({filteredWorkLogs.length})
            </h3>
            <p className="text-sm text-gray-600 dark:text-slate-400">
              Grouped by {grouping.field} with unique ticket estimation
            </p>
          </div>
          <div className="min-w-0 flex-shrink">
            {headerControls}
          </div>
        </div>
      </div>
      <div className="divide-y divide-gray-200 dark:divide-white/10">
        {Object.entries(groupedWorkLogs).map(([groupKey, group]) => (
          <div key={groupKey}>
            <GroupHeader
              group={group}
              groupKey={groupKey}
              groupingField={grouping.field}
              isExpanded={grouping.expanded[groupKey]}
              onToggle={() => onToggleGroupExpansion(groupKey)}
            />
            
            {grouping.expanded[groupKey] && (
              <>
                <GroupStatistics group={group} />
                
                {/* Mobile: Card View */}
                <div className="md:hidden p-4 space-y-4">
                  {group.logs.map(log => (
                    <WorklogCard key={log.id} log={log} />
                  ))}
                </div>

                {/* Desktop: Table View */}
                <div className="hidden md:block overflow-x-auto -mx-4 sm:mx-0">
                  <div className="inline-block min-w-full align-middle">
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-white/10">
                        <TableHeader />
                        <tbody className="bg-white dark:bg-slate-800 divide-y divide-gray-200 dark:divide-white/10">
                          {group.logs.map(log => (
                            <WorklogRow key={log.id} log={log} />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralGroupedView;

